import React from 'react';

interface IHelpProps {
	size?: string;
	fill?: string;
}

export const Help = ({ size = '24', fill }: IHelpProps) => (
	<svg role="img" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-labelledby="helpIcon">
		<title id="helpIcon">help question icon</title>
		<path
			d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02943 7.02944 3 12 3C16.9706 3 21 7.02943 21 12Z"
			stroke={fill || '#3D3D3D'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M9.5 9.50368C9.49931 9.03221 9.63195 8.57016 9.88261 8.17085C10.1333 7.77154 10.4917 7.45124 10.9166 7.24693C11.3416 7.04263 11.8156 6.96263 12.284 7.01618C12.7524 7.06973 13.1961 7.25465 13.5639 7.54958C13.9318 7.84452 14.2087 8.23745 14.3627 8.68304C14.5168 9.12862 14.5418 9.60868 14.4346 10.0678C14.3276 10.527 14.0928 10.9465 13.7575 11.2779C13.4222 11.6094 13.0001 11.8393 12.5397 11.941C12.3887 11.9708 12.2525 12.0516 12.154 12.1699C12.0555 12.2882 12.0007 12.4368 11.9987 12.5907V13.6667"
			stroke={fill || '#3D3D3D'}
			strokeWidth="2"
			strokeLinecap="square"
			strokeLinejoin="round"
		/>
		<path
			d="M12.1042 16.7916C12.0466 16.7916 12 16.745 12 16.6875C12 16.63 12.0466 16.5833 12.1042 16.5833"
			stroke={fill || '#3D3D3D'}
			strokeWidth="2"
		/>
		<path
			d="M12.1042 16.7916C12.1617 16.7916 12.2084 16.745 12.2084 16.6875C12.2084 16.63 12.1617 16.5833 12.1042 16.5833"
			stroke={fill || '#3D3D3D'}
			strokeWidth="2"
		/>
	</svg>
);
